import { TenantService } from '@weave/schema-gen-ts/dist/schemas/phonedata/v1/private/tenant/tenant_service.pb';
import { bindHTTP, SchemaTenantService } from '@frontend/schema';
import { GetTenantTypes } from './types';

const PrivateTenantService = bindHTTP(TenantService);

export const getTenantsWithOrgId = (req: GetTenantTypes['input']): Promise<GetTenantTypes['output']> => {
  return SchemaTenantService.GetTenants(req, {
    skipValidation: true,
  }).catch(() => {
    const emptyResponse: GetTenantTypes['output'] = { tenants: [] };
    return emptyResponse;
  });
};

export const getTenantsWithOrgIds = (orgIds: string[]): Promise<GetTenantTypes['output'][]> => {
  return Promise.all(orgIds.map((orgId) => getTenantsWithOrgId({ orgId: orgId })));
};

export const getTenantDetails = (tenantId: string) => {
  return PrivateTenantService.Read({ id: tenantId }, { skipValidation: true }).then(
    (res) => res.relationalTenant?.tenant
  );
};
